import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'next-i18next';

import FrameStyle from './style';

type FramePropType = {
  icon: string;
  tName: string;
};
const Frame = ({ icon, tName }: FramePropType) => {
  const { t } = useTranslation('business');
  return (
    <FrameStyle>
      <img src={icon} alt={t(tName)} />
      <Typography>{t(tName)}</Typography>
    </FrameStyle>
  );
};

const FrameGroup = ({ frames }: { frames: Array<FramePropType> }) => (
  <Grid spacing={1} container className="box-container" sx={{ width: { lg: '1200px' } }}>
    <Grid item lg={3} xs={12}>
      <Frame {...frames[0]} />
      <Box paddingTop={1} />
      <Frame {...frames[2]} />
    </Grid>
    <Grid item lg={3} xs={12}>
      <Frame {...frames[1]} />
      <Box paddingTop={1} />
      <Frame {...frames[3]} />
    </Grid>
    <Grid item lg={6} sx={{ display: { xs: 'none', lg: 'block' } }} />
  </Grid>
);

export default FrameGroup;
